<template>
  <div class="organizations-container">
    <b-row align-v="start">
      <b-col cols="12" lg="12" md="12" sm="12" xs="12" class="organization-item mt-2 mb-3" v-for="organization in organizations" :key="organization.id">
        <ul class="list-unstyled pt-1 pb-3">
          <OrganizationMedia v-bind:organization="organization" v-bind:type="type"/>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import OrganizationMedia from './OrganizationMedia'

export default {
  name: 'OrganizationsList',
  components: {
    OrganizationMedia
  },
  props: {
    'organizations': Array,
    'type': String
  }
}
</script>

<style lang="scss" scoped>
  .organization-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);

    &:last-child {
      border-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/organizations/OrganizationsList.vue